/*eslint-disable*/
import React from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// @material-ui/icons
import { AccountCircle, Description, Apps, Home } from "@material-ui/icons";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";
import { appsUrl } from '../../config/urls'
import signOut from "helpers/signOut";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  
  const classes = useStyles();
  return (
    <List className={classes.list}>   
     <ListItem className={classes.listItem}>
       <Link to="/"  className={classes.navLink}>    
          <Home className={classes.icons} /> Beranda        
        </Link>
      </ListItem>     
      <ListItem className={classes.listItem}>
      <Link to="/daftar-surat"  className={classes.navLink}>       
          <Description className={classes.icons} /> Ajukan Surat        
        </Link>
      </ListItem>  
      <ListItem className={classes.listItem}>
        <Link to="/surat-saya" className={classes.navLink}>         
            <Apps className={classes.icons} /> Surat Saya          
        </Link>
      </ListItem>     
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText={<img src={props.user.info.FOTO} alt="" style={{width:40, height:40, borderRadius:100, objectFit:'cover'}} />}          
          buttonProps={{
            className: classes.navLink,
            style: {padding:'5px 0px 0px 10px'},
            color: "transparent"
          }}          
          dropdownList={[           
            <div style={{cursor:'pointer'}} onClick={() =>signOut()} className={classes.dropdownLink}>      
              Logout
            </div>
          ]}
        />
      </ListItem>
    </List>
  );
}
